const isExternalLink = to =>
  /^https?:\/\//.test(to) || /^http?:\/\//.test(to);

export default isExternalLink;
